import { combineReducers, createStore } from 'redux'
import { selectedProgramReducer } from '../reducers/selectedProgramReducer.js'
import { selectedScheduleReducer } from '../reducers/selectedScheduleReducer.js'
import { selectedCategoryUserReducer } from '../reducers/selectedCategoryUserReducer.js'
import { selectedMetodePembayaranCorporate } from '../reducers/selectedMetodePembayaran.js'
import { inputChangeReducer } from '../reducers/inputChangeReducer.js'
import { participantsReducer } from '../reducers/participantsReducer.js'
import { nominalPaymentReducer } from '../reducers/nominalPaymentReducer.js'
import { statusBarTransaksi } from '../reducers/statusBarTransaksi.js'
import { selectedBPReducer } from '../reducers/selectedBPReducer.js'
import { selectedBPScheduleReducer } from '../reducers/selectedBPScheduleReducer.js'
import { bpParticipantsReducer } from '../reducers/bpParticipantsReducer.js'
import { validateProgramParticipants } from '../reducers/validateProgramParticipants.js'

const rootReducer = combineReducers({
    bpParticipants: bpParticipantsReducer,
    bpScheduleSelected: selectedBPScheduleReducer,
    bpSelected: selectedBPReducer,
    programSelected: selectedProgramReducer,
    scheduleSelected: selectedScheduleReducer,
    categoryUserSelected: selectedCategoryUserReducer,
    metodePembayaranCorporateSelected: selectedMetodePembayaranCorporate,
    dataInputRegistration: inputChangeReducer,
    participants: participantsReducer,
    nominalPayment: nominalPaymentReducer,
    statusBarTransaksi: statusBarTransaksi,
    validateProgramParticipants: validateProgramParticipants,
})

const store = createStore(rootReducer)

export default store